var _defs, _rect, _rect2, _polygon, _path, _path2, _path3, _rect3, _polygon2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgProductionNav(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Calque_1",
    "data-name": "Calque 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#efefef;}"))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 13.92,
    y: 11.23,
    width: 1,
    height: 2.16
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 13.92,
    y: 16.89,
    width: 1,
    height: 2.17
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "13.92 24.73 14.92 24.73 14.92 22.56 13.92 22.56 13.92 22.56 13.92 24.73"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M5,10.73H20a.76.76,0,0,0,.75-.75V9A.75.75,0,0,0,20,8.23H5A.75.75,0,0,0,4.22,9v1A.76.76,0,0,0,5,10.73Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M27,13.89H10a.76.76,0,0,0-.75.75v1a.75.75,0,0,0,.75.75H27a.75.75,0,0,0,.75-.75v-1A.76.76,0,0,0,27,13.89Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M18.68,21.31v-1a.75.75,0,0,0-.75-.75h-13a.76.76,0,0,0-.75.75v1a.75.75,0,0,0,.75.75h13A.74.74,0,0,0,18.68,21.31Z"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 6.22,
    y: 25.23,
    width: 21.5,
    height: 2.5,
    rx: 0.75
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "14.42 6.91 15.92 5.45 17.42 3.98 14.42 3.98 11.42 3.98 12.92 5.45 14.42 6.91"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgProductionNav);
export default __webpack_public_path__ + "static/media/Production-NAV.5d07a41200bb4e68c8bd1ae61e961dc2.svg";
export { ForwardRef as ReactComponent };